import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PopupControl } from 'src/app/models/popup-control.model';
import { ControlPopUpModule } from '../../control-pop-up/control-pop-up.module';
import { DxButtonModule, DxCheckBoxModule, DxScrollViewModule, DxTextBoxModule } from 'devextreme-angular';
import { BookmarksGroupOperator } from '../operators/bookmarks-group.operator';
import { Bookmark } from '../models/bookmark.model';
import { NotificationService } from 'src/app/services/notification.service';

@Component({
    selector: 'app-create-bookmark-pop-up',
    imports: [
        CommonModule,
        ControlPopUpModule,
        DxScrollViewModule,
        DxButtonModule,
        DxTextBoxModule,
        DxCheckBoxModule,
    ],
    templateUrl: './create-bookmark-pop-up.component.html',
    styleUrls: ['./create-bookmark-pop-up.component.scss'],
	standalone: true
})
export class CreateBookmarkPopUpComponent implements OnInit {

	@Input()
	public popupControl: PopupControl;

	@Input()
	public bookmarksGroupOperator: BookmarksGroupOperator;

	public bookmark: Bookmark = new Bookmark(undefined, undefined, false, undefined);

	public createBookmark(): void {
		const promise$ = this.bookmarksGroupOperator.createBookmark(this.bookmark.name, this.bookmark.isDefault);

		promise$.then(
			(bookmark: Bookmark) => {
				this.popupControl.hide();

				this._notificationService.success("Bookmark successfully created.");
			}
		);
	}

	constructor(
		private _notificationService: NotificationService,
	) { }

	ngOnInit(): void {
		this.popupControl.onShown.subscribe(
			(_) => {
				this.bookmark = new Bookmark(undefined, undefined, false, undefined);
			}
		);
	}
}
